import { FormControl, InputLabel, MenuItem, Select, TextField } from "@mui/material";
import React, { useEffect, useState } from "react";
import { useLoad } from "../../context";
import ApiServices from "../../services/apiServices";
import Mask from "../../services/mask";
import "./index.css";
import { toast } from "react-toastify";
import { useNavigate } from "react-router";

export default function Contatos() {
  const navigate = useNavigate();
  const { setLoad } = useLoad();
  const [eu, setEu] = useState([]);
  const [assunto, setAssunto] = useState([]);
  const [fale, setFale] = useState({
    faleConoscoAssuntoId: "",
    mensagem: "",
  });
  const [jaEnviado, setJaEnviado] = useState(false);


  async function fnEu() {
    try {
      setLoad(true);
      let response = await ApiServices.apiGet("eu");
      setEu(response.data);
      setFale(response.data)
    } catch (err) {
      console.error("err", err);
    } finally {
      setLoad(false);
    }
  }
  async function fnAssunto() {
    try {
      setLoad(true);
      let response = await ApiServices.apiGet("faleconosco/assunto");
      setAssunto(response.data);
    } catch (err) {
      console.error("err", err);
    } finally {
      setLoad(false);
    }
  }

  async function fnEnviarFale() {
    try {
      if (jaEnviado) {
        return;
      }

      setJaEnviado(true);
      setLoad(true);

      let response = await ApiServices.apiPost("faleconosco/criar", fale);
      
      if (response.statusCode === 200) {
        toast.success(response.data);
        navigate('/home');
        setJaEnviado(false);
        
      } else {
        toast.error(response.message);
        setJaEnviado(false);
      }
      

    } catch (err) {
      console.error("err", err);
    } finally {
      setLoad(false);
    }
  }

  useEffect(() => {
    fnEu();
    fnAssunto();
  }, []); //eslint-disable-line react-hooks/exhaustive-deps
  return (
    <>
      <div className="d-flex justify-content-center">
        <div className="container">
          <div className="row pt-5">
            <h2>Fale conosco</h2>
            <span className="text-center p-5">
              Caso tenha alguma dúvida, que não foi respondida no FAQ, você pode abrir um chamado
              para nossa equipe de atendimento. Nosso prazo para retorno é de até 72hs, nosso retorno
              será pelo e-mail do seu cadastro no programa. Caso queira falar com um atendente,
              ligue para 0800 591 0127. Horário de atendimento: de segunda a sexta, das 09hs às
              18hs.
            </span>
            <div className="col-md-6 mt-3">
              <TextField
                fullWidth
                label="Nome"
                value={eu.nome}
                InputLabelProps={{ shrink: true }}
                disabled
              />
            </div>
            <div className="col-md-3 mt-3">
              <TextField
                fullWidth
                label="CPF / CNPJ"
                value={Mask.cpfCnpj(eu.cpfCnpj)}
                InputLabelProps={{ shrink: true }}
                disabled
              />
            </div>
            <div className="col-md-3 mt-3">
              <TextField
                fullWidth
                label="Perfil"
                value={eu.role?.displayName}
                InputLabelProps={{ shrink: true }}
                disabled
              />
            </div>{" "}
            <div className="row ">
              <div className="col-md-6  mt-3">
                <TextField
                  fullWidth
                  label="E-mail"
                  value={eu.email}
                  InputLabelProps={{ shrink: true }}
                  disabled
                />
              </div>

              <div className="col-md-6  mt-3">
                <FormControl fullWidth>
                  <InputLabel id="demo-simple-select-label">Assunto</InputLabel>
                  <Select
                    labelId="demo-simple-select-label"
                    id="demo-simple-select"
                    label="Assunto"

                    value={fale.faleConoscoAssuntoId}
                    onChange={(e) => { setFale(prev => ({ ...prev, faleConoscoAssuntoId: e.target.value })) }}
                  //</FormControl>onChange={(e) => {}}
                  >
                    {assunto.map((e) => (
                      <MenuItem key={e.faleConoscoAssuntoId} value={e.faleConoscoAssuntoId}>
                        {e.descricao}
                      </MenuItem>
                    ))}
                  </Select>
                </FormControl>
              </div>

              {/* <div className="col-md-3">
                <TextField
                  fullWidth
                  label="ID do Cliente"
                  value={Mask.cpfCnpj(eu.cpfCnpj)}
                  InputLabelProps={{shrink: true}}
                  disabled
                />
              </div>
              <div className="col-md-3">
                <TextField
                  fullWidth
                  label="Razão Social"
                  value={eu.role?.displayName}
                  InputLabelProps={{shrink: true}}
                  disabled
                />
              </div> */}
            </div>
            <div className="row d-flex justify-content-center">
              <div className="clo-12 mt-3">
                <TextField
                  fullWidth
                  id="outlined-multiline-static"
                  label="Digite sua mensagem"
                  multiline
                  rows={10}
                  variant="outlined"
                  value={fale.mensagem}
                  onChange={(e) => { setFale(prev => ({ ...prev, mensagem: e.target.value })) }}
                />
              </div>
              <div className="col-md-3 m-5">
                <button className="btn btn-warning py-3" onClick={fnEnviarFale}>ENVIAR</button>
              </div>
            </div>
          </div>
        </div>
      </div>
    </>
  );
}
